const relativeFormatter = new Intl.RelativeTimeFormat("lt", { numeric: "auto" });

/** "vakar", "prieš 3 valandas" — how a date reads on a profile page. */
export function formatRelativeDate(iso: string): string {
  const then = new Date(iso).getTime();
  const diffSec = Math.round((then - Date.now()) / 1000);
  const abs = Math.abs(diffSec);
  if (abs < 60) return relativeFormatter.format(diffSec, "second");
  if (abs < 3600) return relativeFormatter.format(Math.round(diffSec / 60), "minute");
  if (abs < 86400) return relativeFormatter.format(Math.round(diffSec / 3600), "hour");
  if (abs < 604800) return relativeFormatter.format(Math.round(diffSec / 86400), "day");
  if (abs < 2592000) return relativeFormatter.format(Math.round(diffSec / 604800), "week");
  if (abs < 31536000) return relativeFormatter.format(Math.round(diffSec / 2592000), "month");
  return relativeFormatter.format(Math.round(diffSec / 31536000), "year");
}

/** The full date behind the relative one, for a tooltip. */
export function formatFullDate(iso: string): string {
  return new Date(iso).toLocaleString("lt-LT", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** "rugpjūčio 5 d." — the day a thing happened, as a heading rather than a stamp. */
export function formatDayMonth(iso: string): string {
  return new Date(iso).toLocaleDateString("lt-LT", { month: "long", day: "numeric" });
}
